import React from "react";

import CoreListTemplate from "./templates/CoreListTemplate.jsx";

const CoreListPage = () => <CoreListTemplate />;

export default CoreListPage;
